@if ((tableModel$ | async); as tableModel) {
  <p-table [scTableSettings]="tableModel.tableSettings"
           class="mt-3">
    @if (!tableModel.isReadonly) {
      <ng-template pTemplate="tools-panel-right">
        <p-button label="Create new chapter"
                  i18n-label
                  (onClick)="newChapterDialog()"
                  styleClass="p-button-outlined">
        </p-button>
      </ng-template>
    }
    @if (!tableModel.isReadonly; as rowData) {
      <ng-template pTemplate="row-actions"
                   let-rowData>
        <i class="fas fa-trash"
           (click)="deleteChapter(rowData.id)"
           pTooltip="Click to delete chapter"
           tooltipPosition="top"
           i18n-pTooltip></i>
      </ng-template>
    }
  </p-table>
}